import { configureStore } from "@reduxjs/toolkit";
import headerReducer from "./headerSlice";
import userReducer from "./userSlice";

// 1. Load state from sessionStorage
const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem("reduxUserState");
    if (serializedState === null) {
      return undefined; // Let Redux initialize using initialState in userSlice
    }
    const persisted = JSON.parse(serializedState);
    return {
      user: {
        ...persisted,
        firstname: persisted.firstname || sessionStorage.getItem("fname") || "",
        surname: persisted.surname || sessionStorage.getItem("lname") || "",
        gender: persisted.gender || sessionStorage.getItem("gender") || "",
        date: persisted.date || sessionStorage.getItem("dob") || "",
        nin: persisted.nin || sessionStorage.getItem("nin") || "",
      },
    };
  } catch (err) {
    console.error("Could not load state from session storage", err);
    return undefined;
  }
};

// 2. Save state to sessionStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state.user);
    sessionStorage.setItem("reduxUserState", serializedState);
  } catch (err) {
    console.error("Could not save state to session storage", err);
  }
};

const preloadedState = loadState();

const store = configureStore({
  reducer: {
    header: headerReducer,
    user: userReducer,
  },
  preloadedState, // Inject the saved state on startup
});

// 3. Subscribe to changes: save the state every time it updates
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
